export class Tools {
  static getParam(paramName) {
    return new URL(window.location.href).searchParams.get(paramName);
  }
}
